import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";

// STAGING: keep search engines out of new.studiowebvip.com.
// Remove this block when the site moves to studiowebvip.com.
const robots = document.createElement("meta");
robots.name = "robots";
robots.content = "noindex, nofollow";
document.head.appendChild(robots);

// Canonical points to the final domain so no SEO value is split
const canonical = document.createElement("link");
canonical.rel = "canonical";
canonical.href = "https://studiowebvip.com/";
document.head.appendChild(canonical);
document.title = "Studio Web VIP | Paid Acquisition Systems for Service Businesses";
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-252" data-mp="2tyv7f79lslke" />);
}